'use client';

import {
  markFirstPageInteraction,
  readHasFirstPageInteraction,
  subscribeFirstPageInteraction,
} from '@/lib/ui/first-page-interaction';
import { useCallback, useSyncExternalStore } from 'react';

function getServerSnapshot() {
  return false;
}

export function useFirstPageInteraction() {
  const interacted = useSyncExternalStore(
    subscribeFirstPageInteraction,
    readHasFirstPageInteraction,
    getServerSnapshot
  );

  const markInteracted = useCallback(() => {
    markFirstPageInteraction('manual');
  }, []);

  return {
    hasInteracted: interacted,
    markInteracted,
  };
}
